module.exports = __webpack_public_path__ + "static/media/master-ac-location.9f88aa8e.png";